import { CurrencyCodes } from '../../../view/helpers/currency_helpers';

export interface IDaysOfWeek<T> {
	mon: T;
	tue: T;
	wed: T;
	thu: T;
	fri: T;
	sat: T;
	sun: T;
}

export interface IPricing {
	id: string;
	property_id: string;
	currency: string;
	start_date: string;
	end_date: string;
	los_availability: IDaysOfWeek<
		[boolean, boolean, boolean, boolean, boolean, boolean, boolean]
	>;
	managed_by: string;
	name: string;
	pax: Array<{ factor: number; from: number; to: number }>;
	prices: {
		type: string;
		base: {
			duration: number;
			value: number;
		};
		los: IDaysOfWeek<
			[number, number, number, number, number, number, number]
		>;
	};
}

export interface IPricingUi {
	id: string;
	property_id: string;
	name: string;
	start_date: string;
	end_date: string;
	min_stay: number;
	seven_night_discount: number;
	twenty_eight_night_discount: number;
	arrival_days: IDaysOfWeek<boolean>;
	departure_days: IDaysOfWeek<boolean>;
	prices: IDaysOfWeek<number>;
	managed_by: string;
	currency: CurrencyCodes;
}

export interface IPricingUiWithId extends IPricingUi {
	id: string;
}

export interface IPricingValidation {
	id: string;
	present: boolean;
	end: string | Date;
	gaps: Array<{ from: string; to: string }>;
	unpricedNights: number;
	valid: boolean;
}

interface IDiscount {
	nights: number;
	factor: number;
}

type CheckInDays = 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun';

export interface IPricingDefault {
	currency: string;
	min_stay: number;
	min_price: number;
	checkin_days: CheckInDays[];
	discounts: IDiscount[];
}

export interface IPricingType {
	type: 'manual' | 'automatic';
	automatic_rate: string;
}

export interface ISmartPrice {
	date: string;
	price: number;
}

export interface IPricingOverride {
	effective_date: string;
	min_stay?: number;
	price?: number;
	discounts?: [];
	checkin_available?: boolean;
}

export enum SMART_RATE {
	daily = 'daily',
	every_2_days = 'every_2_days',
}
